// src/lib/googleReviewDesigns.js
// Liste des modèles de design de la page "Avis Google".

export const DEFAULT_TAP_TEXT = 'Appuyez ou scannez pour nous laisser un avis sur'

export const REVIEW_DESIGNS = [
  {
    id: 'simple',
    name: 'Simple',
    description: 'Logo, note et bouton (modèle d’origine)',
    accent: null, // n'utilise pas la couleur d'accent
    swatch: 'linear-gradient(135deg, #e2e8f0, #cbd5e1)',
  },
  {
    id: 'card',
    name: 'Carte NFC',
    description: 'Carte blanche : icône NFC, QR code, 5 étoiles',
    accent: '#111827',
    swatch: 'linear-gradient(135deg, #ffffff, #e5e7eb)',
  },
  {
    id: 'neon',
    name: 'Néon',
    description: 'Fond sombre, note lumineuse, QR encadré',
    accent: '#22d3ee',
    swatch: 'linear-gradient(135deg, #22d3ee, #a855f7)',
  },
  {
    id: 'ticket',
    name: 'Ticket',
    description: 'Ticket de caisse perforé avec code-barres',
    accent: '#1c1917',
    swatch: 'linear-gradient(135deg, #fffdf6, #e7e0cc)',
  },
  {
    id: 'poster',
    name: 'Affiche',
    description: 'Grande note typographique sur fond de couleur',
    accent: '#1a3cff',
    swatch: 'linear-gradient(135deg, #1a3cff, #4c6bff)',
  },
  {
    id: 'bubble',
    name: 'Conversation',
    description: 'Bulles de discussion qui invitent à noter',
    accent: '#2563eb',
    swatch: 'linear-gradient(135deg, #dbeafe, #2563eb)',
  },
]

export function getReviewDesign(id) {
  return REVIEW_DESIGNS.find((d) => d.id === id) || REVIEW_DESIGNS[0]
}
